const EVENTS = {
    TAP: 'tapper_tap',
};

export default class Tapper extends Phaser.GameObjects.Container {
    private area!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);
        this.scene.layers.tapper.add(this);

        this.setupArea();
    }

    static get EVENTS() {
        return EVENTS;
    }

    setupArea() {
        let x = this.scene.cameras.main.centerX;
        let y = this.scene.cameras.main.centerY;

        let width = this.scene.cameras.main.width;
        let height = this.scene.cameras.main.height;

        this.area = this.scene.add.image(x, y, 'atlas', 'blank');
        this.area.setDisplaySize(width, height);
        this.area.setAlpha(0.01);
        this.add(this.area);

        this.area.setInteractive({ useHandCursor: true });
        this.area.on('pointerdown', () => this.scene.events.emit(EVENTS.TAP));
    }
}
